import styled from 'styled-components';

export const BlockMessage = styled.span`
	font-size: 30px;
`;

export const TimeStamp = styled.span`
	font-size: 12px;
	margin-left: 10px;
`;

export const BlockDescriptionContainer = styled.div``;
